import configFile from "../config.json";

let config: typeof configFile;

export function getConfig() {
  if (!config) {
    const { REACT_APP_USE_CONFIG } = process.env;

    if (REACT_APP_USE_CONFIG === "dev") {
      config = require("../config.dev.json");
    } else {
      if (!window.env) throw new Error("No config found");
      config = window.env;
    }
  }

  return config;
}

export default function useGetConfig() {
  try {
    return {
      config: getConfig(),
      configError: null,
    };
  } catch (error) {
    return {
      config: null,
      configError: error,
    };
  }
}
